import { Injectable } from '@angular/core';
import { Cargochief } from '../cargochief/cargochief.service';

@Injectable({
	providedIn: 'root',
})
export class UserCarrierMapHelperService {
	constructor(private cargochief: Cargochief) {}

	createPayload(userId: number, carrierId: string, deleted: boolean): any {
		return {
			assigneeId: userId,
			userId: this.cargochief.USER_ID,
			carrierId: carrierId,
			accountId: this.cargochief.ACCOUNT_ID,
			deleted: deleted,
		};
	}
}
